import { ICreateRentComp } from "pages/Comps/components/RentCompModal/interfaces";
import { apiClient } from "lib/apiClient";
import { IResearchCompContext } from "features/Research/types";

type Response = {
  name: string;
  ownerRelatedStatus: string;
  closingDate: string;
  pricePerUnit: number;
  properties: string[];
  participantData: string;
  verificationSources: string[];
  participantCompanyName: string;
  participantName: string;
  participantPhone: string;
  participantEmail: string;
  sellerLegalName: string;
  sellerTrueName: string;
  sellerProfitType: string;
  buyerLegalName: string;
  buyerTrueName: string;
  buyerProfitType: string;
  id: string;
};

export const addRentComp = async (
  request: ICreateRentComp,
  originalCompId: string | null,
  researchContext?: IResearchCompContext
): Promise<Response> => {
  const response = await apiClient.post("/comps/rent", request, {
    params: {
      originalCompId: originalCompId || undefined,
      workItemId: researchContext?.workItemId,
      workItemVersion: researchContext?.version,
    },
  });

  return response.data;
};
